import { emptyObj } from 'util/objects'

export default function selectJiraSitesById(state, { source }) {
  if (source === 'jiraServer') return emptyObj
  return state.integrations.thirdPartyData[source].sites.byId
}
